import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { WarehouseDataForm, WarehouseFilters } from '../../models/Warehouse';

const useWarehouseService = () => {
  const { doGet, doPost, doPut, doDelete } = useFetch();

  const [fetchingGetWarehouses, setFetchingGetWarehouses] = useState(false);
  const [fetchingShowWarehouse, setFetchingShowWarehouse] = useState(false);
  const [fetchingCreateWarehouse, setFetchingCreateWarehouse] = useState(false);
  const [fetchingStoreWarehouse, setFetchingStoreWarehouse] = useState(false);
  const [fetchingEditWarehouse, setFetchingEditWarehouse] = useState(false);
  const [fetchingUpdateWarehouse, setFetchingUpdateWarehouse] = useState(false);
  const [fetchingDeleteWarehouse, setFetchingDeleteWarehouse] = useState(false);
  const [fetchingActiveWarehouse, setFetchingActiveWarehouse] = useState(false);

  const getWarehouses = (filters: WarehouseFilters, events: ServiceEvents = {}) => {
    const queryString = Object.entries(filters).map(([k, v]) => `${k}=${v}`).join('&');
    doGet({ ...events, url: `${EndPoints.WAREHOUSES.GET_WAREHOUSES}?${queryString}`, setFetching: setFetchingGetWarehouses });
  };

  const createWarehouse = (events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.WAREHOUSES.CREATE_WAREHOUSE, setFetching: setFetchingCreateWarehouse });

//   const showWarehouse = (id: number, events: ServiceEvents = {}) =>
//     doGet({ ...events, url: EndPoints.WAREHOUSES.SHOW_WAREHOUSE.replace(':id', id.toString()), setFetching: setFetchingShowWarehouse });

  const storeWarehouse = (data: WarehouseDataForm, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.WAREHOUSES.STORE_WAREHOUSE, body: data, setFetching: setFetchingStoreWarehouse });

  const editWarehouse = (id: number, events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.WAREHOUSES.EDIT_WAREHOUSE.replace(':id', id.toString()), setFetching: setFetchingEditWarehouse });

  const updateWarehouse = (id: number, data: WarehouseDataForm, events: ServiceEvents = {}) =>
    doPut({ ...events, url: EndPoints.WAREHOUSES.UPDATE_WAREHOUSE.replace(':id', id.toString()), body: data, setFetching: setFetchingUpdateWarehouse });

  const deleteWarehouse = (id: number, events: ServiceEvents = {}) =>
    doDelete({ ...events, url: EndPoints.WAREHOUSES.DELETE_WAREHOUSE.replace(':id', id.toString()), setFetching: setFetchingDeleteWarehouse });

  const activeWarehouse = (id: number, active: boolean, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.WAREHOUSES.ACTIVE_WAREHOUSE.replace(':id', id.toString()), body: { active }, setFetching: setFetchingActiveWarehouse });

  return {
    fetchingGetWarehouses,
    fetchingShowWarehouse,
    fetchingCreateWarehouse,
    fetchingStoreWarehouse,
    fetchingEditWarehouse,
    fetchingUpdateWarehouse,
    fetchingDeleteWarehouse,
    fetchingActiveWarehouse,
    getWarehouses,
    // showWarehouse,
    createWarehouse,
    storeWarehouse,
    editWarehouse,
    updateWarehouse,
    deleteWarehouse,
    activeWarehouse,
  };
};

export default useWarehouseService;
